// eslint-disable-next-line no-unused-vars

function getConfigFile(env){
    var configLocation = (env.NODE_ENV == "production" ? "" : "public/");
    return require("../" + configLocation + "config.json"); //require('../public/config.json'); 
}

var constants = {
    async setGlobalProps(app, env){
        var props = app.config.globalProperties;

        var url = env.VUE_APP_API_URL;

        props.$STATE_NAME = "pes-state-";
        props.$DEFAULT_TIMER = 6000;

        props.$OK = "OK"
        props.$FORM_MODE_VIEW = "View"
        props.$FORM_MODE_CREATE = "Create"
        props.$FORM_MODE_EDIT = "Edit"
        props.$FORM_MODE_DELETE = "Delete"
        props.$FORM_MODE_UNCHANGED = "Unchanged"
        props.$FORM_MODE_HISTORY = "History"        
        props.$API_URL = url
        props.$AUTH_URL = url + "auth/menu" //env.VUE_APP_API_URL + "auth/menu"
        props.$UTIL_URL = url + "util/" //env.VUE_APP_API_URL + "util/"s

        props.$APPROVAL_STATUS = {
            WAITING_FOR_APPROVAL : "WAITING FOR APPROVAL",
            APPROVED : "APPROVED",
            REJECTED : "REJECTED",
        }

        props.$ACCOUNT = {
            USER : "USER",
            ADMIN_HO : "ADMIN HO",
            ADMIN_UNIT: "ADMIN UNIT",
            OU_HEAD : "OU HEAD",            
        }        

        props.$Status_Promotion = {
            REQUESTED : "REQUESTED",
            APPROVED : "APPROVED",
            REJECTED: "REJECTED",
            SYNC: "SYNCED TO FIORI",
            CANCELLED: "CANCELLED PROMOTION",            
        }

        props.$Status_Appraisal = {
            CREATED : "CREATED",
            SYNC : "SYNC TO HCM",
            UPDATED: "UPDATED",
        }

        props.$Action_Role = {
            User: "User",
            Superior: "Superior",
            Head: "Head Superior",
            OU_Head: "OU Head",
            Admin_Unit: "Admin Unit",
            Admin_HO : "Admin HO",
            Functional: "Functional"
        }

        props.$TYPE= [
            "Y","N"
        ]
    
    }
}

export default constants

